import React from "react";

export default function CitizenshipSection() {
  return (
    <section
      id="citizenship"
      class="py-5"
      style={{ backgroundColor: "#f8f4fb" }}
    >
      <div class="container py-5">
        <div class="section-title citizenship-title">
          <h2 class="mb-3">U.S. Citizenship , <span style={{fontWeight:'bold'}}>N-400</span></h2>
          <p>Your Pathway To Becoming An American Citizen</p>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <div class="mb-5 animate-on-scroll">
              <h3 class="mb-4">Benefits of U.S. Citizenship</h3>
              <p>
                Becoming a U.S. citizen offers numerous benefits including the
                right to vote, eligibility for federal jobs, ability to travel
                with a U.S. passport, and protection from deportation.
                Citizenship also allows you to petition for family members to
                come to the United States.
              </p>
              <p>
                Immigration Attorney guide you through every step of the
                process, from eligibility assessment to the citizenship
                ceremony.
              </p>
            </div>

            <div class="animate-on-scroll">
              <h3 class="mb-4">Naturalization Process</h3>
              <div class="process-steps">
                <div class="process-step citizenship-step">
                  <div class="step-number">1</div>
                  <div class="step-content">
                    <h4>Eligibility Check</h4>
                  </div>
                </div>
                <div class="process-step citizenship-step">
                  <div class="step-number">2</div>
                  <div class="step-content">
                    <h4>Application Preparation</h4>
                  </div>
                </div>
                <div class="process-step citizenship-step">
                  <div class="step-number">3</div>
                  <div class="step-content">
                    <h4>Biometrics Appointment</h4>
                  </div>
                </div>
                <div class="process-step citizenship-step">
                  <div class="step-number">4</div>
                  <div class="step-content">
                    <h4>Interview Preparation</h4>
                  </div>
                </div>
                <div class="process-step citizenship-step">
                  <div class="step-number">5</div>
                  <div class="step-content">
                    <h4>Oath Ceremony</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <a
              href="#requestform"
              className="redirectToformLink"
              aria-label="inquiry"
            >
              <div class="service-highlight citizenship-highlight animate-on-scroll">
                <h3 class="mb-4">Citizenship Requirements</h3>
                <p>
                 To qualify as per USCIS, you must meet certain eligibility
                 requirements, which summarily are;
                </p>
                <ul>
                  <li>Be at least 18 years old</li>
                  <li>Have been a permanent resident for 3-5 years</li>
                  <li>Demonstrate continuous residence in the U.S.</li>
                  <li>Show physical presence in the U.S.</li>
                  <li>Be able to read, write, and speak basic English</li>
                  <li>Pass a test on U.S. history and government</li>
                  <li>Be a person of good moral character</li>
                </ul>
              </div>
            </a>

            <div class="row mt-4">
              <div class="col-md-6 mb-3 d-flex">
                <a
                  href="#requestform"
                  className="redirectToformLink w-100"
                  aria-label="inquiry"
                >
                  <div class="service-highlight citizenship-highlight animate-on-scroll h-100 d-flex flex-column justify-content-between">
                    <div>
                      <div class="d-flex align-items-center mb-3">
                        <i
                          class="fas fa-book fa-2x me-3"
                          style={{ color: "var(--citizenship)" }}
                        ></i>
                        <h4 class="mb-0">Test Preparation</h4>
                      </div>
                      <p>Civics and English test study materials</p>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-md-6 mb-3 d-flex">
                <a
                  href="#requestform"
                  className="redirectToformLink w-100"
                  aria-label="inquiry"
                >
                  <div class="service-highlight citizenship-highlight animate-on-scroll h-100 d-flex flex-column justify-content-between">
                    <div>
                      <div class="d-flex align-items-center mb-3">
                        <i
                          class="fas fa-comments fa-2x me-3"
                          style={{ color: "var(--citizenship)" }}
                        ></i>
                        <h4 class="mb-0">Interview Coaching</h4>
                      </div>
                      <p>Prepare for your naturalization interview</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
